import BaseApiService from './base/base-api-service'
import type { TravelInfoResponse } from '../types'

/**
 * Represents the Travel Info API service.
 */
export default class TravelInfoService extends BaseApiService {
  constructor(baseUrl: string) {
    super(baseUrl)
  }

  /**
   * Gets travel information.
   * @returns {Promise<TravelInfoResponse>} Travel info API response.
   */
  public async GetTravelInfo(): Promise<TravelInfoResponse> {
    return await this.GetAsync<TravelInfoResponse>(`api2/travelinfo`)
  }
}
